// @ts-nocheck
import {FC} from 'react'
import {ColumnInstance} from 'react-table'
import { DetailBatchRecord } from '../../../../interfaces/_models'

type Props = {
  column: ColumnInstance<DetailBatchRecord>
}

const CustomHeaderColumn: FC<Props> = ({column}) => (
  <>
    {column.Header && typeof column.Header === 'string' ? (
      <th {...column.getHeaderProps()}>{column.render('Header')}</th>
    ) : (
      column.render('Header')
    )}
  </>
)

export {CustomHeaderColumn}
